import React, { useEffect, useState, useRef, memo } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import ic_point from "assets/svg/ic_point.svg";
import { useTranslation } from "react-i18next";

const CookieConsent = memo(({ className, onHandle }) => {
  const [visible, setVisible] = useState(false);
  const popupRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation("translation");

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    setVisible(!consent);
  }, [location]);

  const handleChoice = (value) => {
    localStorage.setItem("cookieConsent", value);
    onHandle(value);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className={className} style={styles.wrapper}>
      <div className={"content"} ref={popupRef} style={styles.popup}>
        <div className="title text-center">{t("textTitelPersonal")}</div>
        <div className="line-view w-full"></div>
        <div className="content-one mb-1">{t("textContentPersonal")}</div>
        <div className="title-2">{t("textContentPersonal1")}</div>
        <div className="flex w-full">
          <img
            className={"flex w-1.5 h-1.5 mt-2"}
            src={ic_point}
            alt="search"
          />
          <div className={"content-one ml-3"}>{t("textContentPersonal2")}</div>
        </div>
        <div className="flex w-full">
          <img
            className={"flex w-1.5 h-1.5 mt-2"}
            src={ic_point}
            alt="search"
          />
          <div className={"content-one ml-3"}>{t("textContentPersonal3")}</div>
        </div>
        <div className="flex w-full">
          <img
            className={"flex w-1.5 h-1.5 mt-2"}
            src={ic_point}
            alt="search"
          />
          <div className={"content-one ml-3"}>{t("textContentPersonal11")}</div>
        </div>

        <div className="title-2 justify-start items-start w-full">
          {t("textContentPersonal4")}
        </div>
        <div className="flex w-full">
          <img
            className={"flex w-1.5 h-1.5 mt-2"}
            src={ic_point}
            alt="search"
          />
          <div className={"content-one ml-3"}>{t("textContentPersonal5")}</div>
        </div>
        <div className="flex w-full">
          <img
            className={"flex w-1.5 h-1.5 mt-2"}
            src={ic_point}
            alt="search"
          />
          <div className={"content-one ml-3"}>{t("textContentPersonal6")} </div>
        </div>
        <div className="content-one justify-start items-start w-full">
          <a
            href="https://ggg.com.vn/chinh-sach-bao-mat-thong-tin/"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#1976d2", fontSize: "13px" }}
          >
            {t("textLinkPolicyPersonal")}{" "}
          </a>
        </div>
        <div style={styles.actions}>
          <button
            style={styles.decline}
            onClick={() => handleChoice("accepted")}
          >
            {t("textConfirmPersonal")}{" "}
          </button>

          <button
            style={styles.accept}
            onClick={() => handleChoice("declined")}
          >
            {t("textCancelPersonal")}{" "}
          </button>
        </div>
      </div>
    </div>
  );
});

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    zIndex: 9999,
    animation: "slideUp 0.4s ease-out",
  },

  popup: {
    maxWidth: 800,
    width: "100%",
    borderTopLeftRadius: "32px",
    borderTopRightRadius: "32px",
    background: "#fff",
    padding: "16px 20px",
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    gap: 15,
    alignItems: "center",
    boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
    boxSizing: "border-box",
  },

  actions: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 10,
  },

  accept: {
    border: "1px solid #808080",
    width: "100%",
    color: "#1a1a1a",
    marginTop: "10px",
    padding: "8px 14px",
    borderRadius: 6,
    cursor: "pointer",
    background: "#fff",
  },

  decline: {
    width: "100%",
    background: "#1a1a1a",
    color: "#ffffff",
    border: "none",
    marginTop: "10px",
    padding: "8px 14px",
    borderRadius: 6,
    cursor: "pointer",
  },
};
export default styled(CookieConsent)`
  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  .line-view {
    height: 1px;
    background: #f2f2f2;
  }
  .title {
    line-height: 24px;
    color: #1a1a1a;
    font-size: 15px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .title-2 {
    line-height: 24px;
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }
  .content-one {
    line-height: 20px;
    color: #808080;
    font-size: 13px;
    font-weight: 400;
    font-family: "Manrope-Medium", sans-serif;
  }
`;
